import du from '../utils/dom-utilities';

class InitBurger {
    constructor() {
        this.burger = '[data-burger="true"]';
        this.burgerNode = null;
        this.burgerNavigation = '[data-burger-navigation]';
        this.actionNodesSelector = '[data-burger-action], a';
        this.openHandler = '[data-burger-action="open"]';
        this.openChildHandler = '[data-burger-action="openChild"]';
        this.closeHandler = '[data-burger-action="close"]';
        this.closeChildHandler = '[data-burger-action="closeChild"]';
        this.activeClass = 'burger--is-active';
        this.overlayClass = 'burger-overlay';
        this.burgerNavigationActiveClass = 'burger__navigation--has-children-open';
    }

    _openBurger() {
        document.querySelector('html').classList.toggle(this.activeClass);
        this.a11y('open');
        this.burgerNode.querySelector(this.closeHandler).focus();
    }

    _closeBurger() {
        document.querySelector('html').classList.remove(this.activeClass);
        this.a11y('close');
    }

    _clickOutter() {

        if (!document.querySelector('html').classList.contains(this.activeClass)) {
            return;
        }

        this._closeBurger();
    }

    _openChildren(event) {
        let targetParent = event.target.parentNode;
        let targetChild = targetParent.querySelector('[data-burger-state]');

        if (!targetChild) {
            return;
        }

        document.querySelector(this.burgerNavigation)
            .classList.add(this.burgerNavigationActiveClass);

        targetChild.setAttribute('data-burger-state', 'open');
    }

    _closeChildren(event) {
        let targetParent = du.getClosest(event.target, '[data-burger-state]');

        if (!targetParent) {
            return;
        }

        document.querySelector(this.burgerNavigation)
            .classList.remove(this.burgerNavigationActiveClass);

        targetParent.setAttribute('data-burger-state', 'close');
    }

    a11y(state) {
        du.queryAll(this.actionNodesSelector, this.burgerNode).forEach((item) => {
            if (state === 'close') {
                item.setAttribute('tabindex', '-1');
            } else if (state === 'open') {
                item.setAttribute('tabindex', '0');
            }
        });
    }

    init(burgerNode) {
        this.burgerNode = burgerNode;
        this.a11y('close');

        document.querySelector(this.openHandler)
            .addEventListener('click', this._openBurger.bind(this));

        document.querySelector(this.closeHandler)
            .addEventListener('click', this._closeBurger.bind(this));

        document.querySelector(`.${this.overlayClass}`)
            .addEventListener('click', this._closeBurger.bind(this));

        du.queryAll(this.openChildHandler)
            .forEach((node) => {
                node.addEventListener('click', (event) => {
                    this._openChildren(event);
                });
            });

        du.queryAll(this.closeChildHandler)
            .forEach((node) => {
               node.addEventListener('click', (event) => {
                    this._closeChildren(event);
                });
            });
    }

};

export default InitBurger;



// WEBPACK FOOTER //
// ./src/main/js/components/burger.js